import React from "react";
import styled from "styled-components";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { LabelH1, P } from "@motorata/base-ui.components.atoms.typography";
import Link from "@motorata/next.components.atoms.link";

const CarShopListSidebar = () => {
  return (
    <Box>
      <Wrapper>
        <LabelH1 display="block" marginBottom="M" color="white" textAlign="center">
          Brakuje u nas Twojego komisu?
        </LabelH1>
        <P small color="white" margin="0 auto" marginBottom="M" maxWidth="900px" textAlign="center">
          Zarejestruj się na naszej platformie i dodaj swój komis samochodowy, aby zwiększyć zasięgi!
        </P>
        <Link type="secondary" href="https://panel.motorata.pl/register">
          Dołącz do nas
        </Link>
      </Wrapper>
    </Box>
  );
};

export default CarShopListSidebar;


const Wrapper = styled.div`
  position: sticky;
  top: 100px;
  padding: ${({ theme }) => theme.space.M};
  background: ${({ theme }) => theme.color.primary};
  border-radius: 10px;
  margin: 0 auto;
  overflow: hidden;

  &::before {
    display: block;
    position: absolute;
    width: 30vw;
    height: 30vw;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.02);
    content: "";
    left: 0;
    top: 0;
    z-index: 0;
  }

  &::after {
    display: block;
    position: absolute;
    width: 30vw;
    height: 30vw;
    border-radius: 50%;
    transform: translate(50%, 50%);
    background: rgba(0, 0, 0, 0.02);
    content: "";
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 800px) {
    padding: ${({ theme }) => theme.space.L};
  }
`;
